import { useSelector } from 'react-redux';
import { registerNotificationToken } from '@data/app/app.thunk';
import useAppDispatch from '@data/useAppDispatch';
import { AppSelector } from '@data/app/app.selector';
import { isSupported as isFirebaseMessagingSupported } from 'firebase/messaging';
import React from 'react';
import {
  fetchNotifications,
  fetchNotificationsCount,
} from '@data/notifications/Notification.thunk';

const useRegisterNotificationService = () => {
  const dispatch = useAppDispatch();
  const notificationToken = useSelector(AppSelector.selectNotificationToken);
  const [isSupported, setIsSupported] = React.useState(false);

  React.useEffect(() => {
    isFirebaseMessagingSupported().then((isSupported) => {
      setIsSupported(isSupported);
    });
  });

  const getNotification = React.useCallback(() => {
    dispatch(fetchNotifications());
    dispatch(fetchNotificationsCount());
  }, [dispatch]);

  const registerNotificationService = (notificationToken: string) => {
    dispatch(registerNotificationToken({ notificationToken }));
  };

  return {
    registerNotificationService,
    isRegistered: Boolean(notificationToken),
    getNotification,
    isSupported,
  };
};

export default useRegisterNotificationService;
